import React from 'react'
import {Content} from '@builder.io/sdk-react'
import {customComponents, builderConfig} from 'hec/builder'
import {CioFacetProvider} from '@/context/cio-facet'
import {PlpServerDataProvider} from 'hec/context/plp-server-data'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import PropTypes from 'prop-types'

export const PlpPageContent = ({data, serverCategoryName = null}) => {
    const config = getConfig()
    return (
        <PlpServerDataProvider serverCategoryName={serverCategoryName}>
            <CioFacetProvider>
                <div className="min-h-screen">
                    <Content
                        model={builderConfig.pageModel}
                        content={data}
                        apiKey={config.app.builder.api}
                        customComponents={customComponents}
                    />
                </div>
            </CioFacetProvider>
        </PlpServerDataProvider>
    )
}

PlpPageContent.propTypes = {
    data: PropTypes.object,
    serverCategoryName: PropTypes.string
}
